/**
 * Énumérations propres à `payroll-service` (v4.1 — §6.11 du guide).
 *
 * Les statuts `PayrollBatchStatus` et `PayrollLineStatus` ne figurent pas dans
 * l'annexe A du PDF : leurs valeurs sont celles exposées dans les descriptions
 * Postman des endpoints `/gw/payroll/api/v1/PayrollBatches/*` (v4.1,
 * collection `docs/guides/v4.1/FlashPay.postman_collection.json`). Les enums
 * `BeneficiaryType` et `FeePayer` sont confirmés en annexe A (section
 * « Énumérations définies dans plusieurs services », p.301).
 */

/** États du cycle de vie d'une paie de masse. */
export const PAYROLL_BATCH_STATUSES = [
  "DRAFT",
  "SIMULATED",
  "PROCESSING",
  "COMPLETED",
  "PARTIALLY_COMPLETED",
  "FAILED",
  "CANCELLED",
] as const;
export type PayrollBatchStatus = (typeof PAYROLL_BATCH_STATUSES)[number];

/** États d'une ligne (un salarié) dans une paie. */
export const PAYROLL_LINE_STATUSES = [
  "PENDING",
  "VALID",
  "INVALID",
  "PROCESSING",
  "PAID",
  "FAILED",
  "REJECTED",
] as const;
export type PayrollLineStatus = (typeof PAYROLL_LINE_STATUSES)[number];

/**
 * Qui supporte les frais de la paie — annexe A v4.1 : `SENDER` (le marchand
 * paie, chaque salarié reçoit son salaire entier) ou `RECEIVER` (frais déduits
 * de chaque salaire).
 */
export const PAYROLL_FEE_PAYERS = ["SENDER", "RECEIVER"] as const;
export type PayrollFeePayer = (typeof PAYROLL_FEE_PAYERS)[number];

/** Type de bénéficiaire d'une ligne — annexe A v4.1 (service payroll). */
export const PAYROLL_BENEFICIARY_TYPES = ["MEMBER", "NON_MEMBER"] as const;
export type PayrollBeneficiaryType = (typeof PAYROLL_BENEFICIARY_TYPES)[number];
